import { Stack } from '@mui/material';
import { TextInput, required } from 'react-admin';
import { UrlInput } from '@app/misc/UrlInput';
import { showModeReadOnlySx } from '@app/root/theme';

export const ExpensesClaimInputs = ({
    readOnly = false,
}: {
    readOnly?: boolean;
}) => {
    return (
        <Stack gap={1} p={1} sx={readOnly ? showModeReadOnlySx : undefined}>
            <TextInput
                source="name"
                helperText={false}
                validate={required()}
                readOnly={readOnly}
            />
            <TextInput
                source="details"
                helperText={false}
                multiline
                readOnly={readOnly}
            />
            <TextInput
                source="appScheme"
                helperText={
                    'The identifier for the mobile app scheme, eg. com.expensya.revamped'
                }
                readOnly={readOnly}
            />
            <UrlInput
                source="url"
                helperText={
                    'The URL of the expenses claim form, eg. https://expensya.com/expenses/claim'
                }
                readOnly={readOnly}
            />
            <UrlInput
                source="docUrl"
                helperText={'Link to the documentation'}
                readOnly={readOnly}
            />
        </Stack>
    );
};
